<template>
  <div v-if="notice">
    <van-notice-bar color="#027AFF" background="#e6f2ff" left-icon="volume-o" scrollable :text="notice.title" style="height: 35px;"></van-notice-bar>
  </div>
</template>

<script>
  export default {
    name: 'MrNoticeBar',
    props: {
      notice: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
